import { render, staticRenderFns } from "./PrivacyStayAwake.vue?vue&type=template&id=2327c9a0&scoped=true"
import script from "./PrivacyStayAwake.vue?vue&type=script&lang=js"
export * from "./PrivacyStayAwake.vue?vue&type=script&lang=js"
import style0 from "./PrivacyStayAwake.vue?vue&type=style&index=0&id=2327c9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327c9a0",
  null
  
)

export default component.exports